import React from "react";
import {motion} from 'framer-motion' 

import client1 from "../style/images/client1.webp";
import client2 from "../style/images/client2.png";
import client3 from "../style/images/client3.png";
import client4 from "../style/images/client4.webp";
import client5 from "../style/images/client5.png";
import client6 from "../style/images/client6.png";
import client7 from "../style/images/client7.png";
import client8 from "../style/images/client8.png";
import client9 from "../style/images/client9.png";
import client10 from "../style/images/client10.png";
import client11 from "../style/images/client11.png";
import client12 from "../style/images/client12.png";


const ClientCarousel = () => {

   const options = {
  loop: true,
  margin: 20,
  autoplay: true,
  autoplayTimeout: 2500,
  autoplayHoverPause: true,
  dots: false,
  nav: false,
  responsive: {
    0: { items: 2 },
    600: { items: 3 },
    1000: { items: 5 },
  },
};
  const clients = [client1, client2, client3, client4, client5, client6, client7 , client8, client9, client10, client11, client12];

  return (
    <section id="clients" className="client-carousel-section" style={{backgroundColor : "#fff" , paddingBottom : 50}}>
      <motion.div
        className="slider-container"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2 className="gallery-title" style={{textAlign : "center" , marginBottom : 0}}>Our Clients</h2>
        <p className="client-carousel-subtitle" style={{textAlign : "center" , color : "#cda555"}}>
          Proud to have collaborated with top brands and partners across industries.
        </p>
        <div className="section-divider"></div>

< div className="slider_container">
        <div className="slider" style={{height : 'auto'}}>
	<div className="slide-track">
         {clients.map((logo, i) => (
		<div className="slide">
			<img src={logo}  alt="" />
		</div>))}
		
	</div>
    </div>
</div>

       
      </motion.div>
    </section>
    
  );
};

export default ClientCarousel;
